import { render, staticRenderFns } from "./MessageTemplateSetup.vue?vue&type=template&id=3c2f50c8&scoped=true&lang=pug&"
import script from "./MessageTemplateSetup.vue?vue&type=script&lang=js&"
export * from "./MessageTemplateSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2f50c8",
  null
  
)

export default component.exports